import React from 'react'

/**
 * Footer association-logo row (Parity V2 A.1).
 * Real logo images ship from public/media/logos/ (downloaded, not hotlinked —
 * see IMAGE_MANIFEST.md). Associations without a cleared logo file keep the
 * monochrome text wordmark until TODO-CLIENT supplies artwork.
 * Desktop >=lg: static centered row. <lg: infinite marquee (CSS keyframes,
 * pauses on hover, disabled under prefers-reduced-motion -> wrapped grid).
 */
const IMAGE_LOGOS: { src: string; alt: string; href: string; imageClass: string }[] = [
  { src: '/media/logos/jack-lingo-realtor.png', alt: 'Jack Lingo REALTOR®', href: 'https://www.jacklingo.com/', imageClass: 'h-12 max-w-[150px]' },
  { src: '/media/logos/carrie-lingo-team.png', alt: 'The Carrie Lingo Team', href: 'https://www.carrielingoteam.com/', imageClass: 'h-10 max-w-[220px]' },
  { src: '/media/logos/realtor-eho.png', alt: 'Equal Housing Opportunity · REALTOR® · MLS', href: 'https://www.hud.gov/program_offices/fair_housing_equal_opp', imageClass: 'h-10 max-w-[160px]' },
]

const TEXT_LOGOS: { name: string; href: string }[] = [
  { name: 'National Assoc. of REALTORS®', href: 'https://www.nar.realtor/' },
  { name: 'Delaware Assoc. of REALTORS®', href: 'https://delawarerealtor.com/' },
  { name: 'Sussex County Assoc. of REALTORS®', href: 'https://www.scaor.com/' },
  { name: 'Bright MLS', href: 'https://www.brightmls.com/' },
]

const LogoRow: React.FC<{ duplicate?: boolean }> = ({ duplicate = false }) => (
  <>
    {IMAGE_LOGOS.map((logo) => (
      <a
        key={logo.src}
        href={logo.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={logo.alt}
        tabIndex={duplicate ? -1 : undefined}
        className="inline-flex h-16 min-w-11 shrink-0 items-center justify-center rounded-md border border-white/15 bg-sand px-4 py-2 shadow-sm transition duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-lg"
      >
        <img src={logo.src} alt="" className={`${logo.imageClass} w-auto object-contain`} loading="lazy" />
      </a>
    ))}
    {TEXT_LOGOS.map((logo) => (
      <a
        key={logo.name}
        href={logo.href}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={duplicate ? -1 : undefined}
        className="flex h-10 shrink-0 items-center whitespace-nowrap font-display text-[11px] font-medium uppercase tracking-[0.15em] text-white/70 transition-colors duration-300 hover:text-white"
      >
        {logo.name}
      </a>
    ))}
  </>
)

const LogoMarquee: React.FC = () => {
  return (
    <div className="logo-marquee overflow-hidden" aria-label="Professional associations and affiliations">
      <div className="logo-marquee-track flex w-max items-center lg:w-auto lg:flex-wrap lg:justify-center lg:gap-x-10 lg:gap-y-6">
        <div className="flex flex-wrap items-center justify-center gap-10 pr-10 lg:gap-x-10 lg:gap-y-6 lg:pr-0">
          <LogoRow />
        </div>
        {/* Duplicate for seamless marquee wrap — mobile only */}
        <div className="logo-marquee-duplicate flex items-center gap-10 pr-10 lg:hidden" aria-hidden="true">
          <LogoRow duplicate />
        </div>
      </div>
    </div>
  )
}

export default LogoMarquee
